export default "static/media/leetcode.651b506.svg"